import { useNuxtApp } from "#app";
export function useCacheBuster(prop) {
  const nuxtApp = useNuxtApp();
  const cacheBusterValue = process.server || nuxtApp.isHydrating ? void 0 : history.state[prop];
  return {
    value: cacheBusterValue
  };
}
